import { HttpMethod } from '@pool-league/shared-util-http';
import {
  DeleteOperation,
  EndpointPathParameters,
  PostOperation,
  PutOperation,
  GetOperation,
  Endpoint,
} from '../operation';

export type CupBasePathParameters = EndpointPathParameters<
  'seasonId' | 'format'
>;

export type CupCreatePathParameters = CupBasePathParameters;

const CUP_BASE_PATH: Endpoint<keyof CupBasePathParameters> = [
  'seasons',
  { param: 'seasonId' },
  'ko',
  { param: 'format' },
];

export const CUP_CREATE: PutOperation<keyof CupBasePathParameters> = {
  path: CUP_BASE_PATH,
  method: HttpMethod.PUT,
};

export type CupAddEntrantPathParameters = CupBasePathParameters;
export const CUP_ADD_ENTRANT: PostOperation<keyof CupAddEntrantPathParameters> =
  {
    path: [...CUP_BASE_PATH, 'entrants'],
    method: HttpMethod.POST,
  };

export type CupDeleteEntrantPathParameters = CupBasePathParameters &
  EndpointPathParameters<'entrantId'>;

export const CUP_DELETE_ENTRANT: DeleteOperation<
  keyof CupDeleteEntrantPathParameters
> = {
  path: [...CUP_BASE_PATH, { param: 'entrantId' }],
  method: HttpMethod.DELETE,
};

export type CupGetRoundsPathParameters = CupBasePathParameters;
export const CUP_GET_ROUNDS: GetOperation<keyof CupGetRoundsPathParameters> = {
  path: [...CUP_BASE_PATH, 'rounds'],
  method: HttpMethod.GET,
};
